<tam-dialog tid="note_automationn_dialog" [opened]="opened" dialogWidth="614px" contentHeight="399"
    titleName="{{'workflow.tamale_automation' | stringLiterals}} - {{'general.create_a_note' | stringLiterals}}"
    (keydown.esc)="onCancelBtnClick($event)" class="automation-dialog-container">
    <ng-template #title>
        <span class="dialog-title">{{diglogTitle}}</span>
        <smart-icon class="dialog-close dark" name="close" (click)="onCancelBtnClick($event)">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="bodyContainer filter-body-container">
            <div class="top-line">
                <kendo-combobox [popupSettings]="{appendTo: 'component'}" #dropDownEntryType
                    [data]="filteredNoteTypeCandidates" [(ngModel)]="selectedNoteType" textField="name"
                    class="entity-type" valueField="id" [filterable]="true" (selectionChange)="onNoteTypeChange($event)"
                    (filterChange)="onFilterChange($event,dropDownEntryType)"
                    placeholder="{{'workflow.select_a_note_type' | stringLiterals}}" [disabled]="isUpdateANote">
                </kendo-combobox>
            </div>
            <div class="dynamic-rows-container" *ngIf="isLoaded && this.mappingMetadataList.length > 0">
                <div class="fixed-header-row">
                    <div class="fld-note-col"><span class="header-span">{{'workflow.fields_in_note' |
                            stringLiterals}}</span></div>
                    <div class="map-icon-col"></div>
                    <div class="fld-task-col"><span class="header-span">{{'workflow.fields_in_task' |
                            stringLiterals}}</span></div>
                </div>

                <div class="mapping-item-wrapper" *ngFor="let metaItem of mappingMetadataList">
                    <div class="fld-note-col">
                        <input type="text" class="col-ctrl tam-textbox" value="{{metaItem.nameOfFieldInTemplate}}"
                            readonly />
                    </div>
                    <div class="map-icon-col">
                        <smart-icon name="map-fields" class="light medium non-clickable"
                            iconClassList="icon non-clickable">
                        </smart-icon>
                    </div>
                    <div class="fld-task-col">
                        <kendo-dropdownlist *ngIf="!metaItem.isMultipleSelection"
                            [popupSettings]="{appendTo: 'component'}" class="fld-task-ctrl"
                            [(value)]='metaItem.fieldsInWorkflow' [data]="metaItem.dataSourceForSingleSelection"
                            (selectionChange)="onMetaItemFieldsChange($event)" [filterable]="false" textField="key"
                            valueField="value"></kendo-dropdownlist>
                        <multi-sel-dropdown-filter class="fld-task-ctrl" *ngIf="metaItem.isMultipleSelection"
                            [dropdownConfig]="metaItem.dataSourceForMultipleSelection">
                        </multi-sel-dropdown-filter>

                    </div>
                    <div class="mapping-operation-col" *ngIf="metaItem.isDeletable">
                        <smart-icon name="trash" (click)="onDeleteMetaItem(metaItem)" class="light delete-btn small">
                        </smart-icon>
                    </div>
                </div>
            </div>
            <div class="tam-form-help" *ngIf="!isMappingValid && isSaveBtnClicked && !isUpdateANote">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help"
                *ngIf="isSaveBtnClicked && this.mappingMetadataList.length === 0 && isUpdateANote">
                {{'general.required_field_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="isSaveBtnClicked && this.mappingMetadataList.length > 0 && isUpdateANote">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class=" icon-add-bottom" tid="field-add" *ngIf="isLoaded">
                <div class="icon-plus">
                    <kendo-dropdownbutton [popupSettings]="{appendTo: 'root'}" [data]="templateFieldCandidates"
                        textField="nameOfFieldInTemplate" valueField="fieldInTemplate" [iconClass]="'k-button'">
                    </kendo-dropdownbutton>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <button tid="cancel_Automation_Modification" tam-button tamType="tertiary" tamSize="normal"
            class="dialog-button dialog-cancel footer-research-button"
            (click)="onCancelBtnClick($event)">{{'general.cancel' |
            stringLiterals}}</button>
        <button tid="save_Automation_Modification" tam-button tamType="primary" tamSize="normal"
            class="dialog-button dialog-publish footer-research-button"
            (click)="onClickSaveBtn($event)">{{'general.save' |
            stringLiterals}}</button>
    </ng-template>
</tam-dialog>